var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as VPError from "../VPError";
export const exchangeCognitoToken = (client, accessToken, idToken) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: gql `
      mutation SignIn($accessToken: String!, $idToken: String) {
        signinUserMutation(input: { accessToken: $accessToken, idToken: $idToken }) {
          authToken
          returnTo
          errors {
            message
            path
          }
        }
      }
    `,
        variables: {
            accessToken,
            idToken,
        },
    });
    return {
        authToken: data.signinUserMutation.authToken,
        returnTo: data.signinUserMutation.returnTo,
        errors: VPError.fromGqlCollection(data.signinUserMutation.errors),
    };
});
//# sourceMappingURL=cognitoSignin.js.map